export default [
    {
        path: '/railway-structure/station/list',
        name: 'railway_structure-station-list',
        component: () => import('@/views/apps/railway_structure/station/views/List.vue'),
        meta: {
            resource: 'station',
            action: 'read',
            pageTitle: 'Станции',
            breadcrumb: [
                {
                  text: 'Структура ЖД',
                    active: true,
                },
                {
                  text: 'Станции ЖД',
                  active: true,
                },
            ],
        },
    },
    {
        path: '/railway-structure/station/view/:id',
        name: 'railway_structure-station-view',
        component: () => import('@/views/apps/railway_structure/station/views/Details.vue'),
        meta: {
            resource: 'railway',
            action: 'read',
            pageTitle: 'Станции',
            breadcrumb: [
                {
                    text: 'Структура ЖД',
                    active: true,
                },
                {
                    text: 'Станции',
                    to: {
                        name: 'railway_structure-station-list'
                    }
                },
                {
                    text: 'Детали',
                    active: true
                },
            ],
        },
    },
]
